import styled from 'styled-components'
import { images } from '../../helpers/PreCache'

export const ProfilePg = styled.div`
  min-height: calc(100vh - 140px);
  padding-top: 150px;
  background-color: black;
  background-image: url(${images.mainBg});
  background-attachment: fixed;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;

  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 100px;

  @media only screen and (max-width: 600px) {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 60px;
  }

  .content-container {
    display: flex;

    @media only screen and (max-width: 600px) {
      flex-direction: column;
      position: relative;
      z-index: 2;
    }
  }
`
